import {Input, InputProps} from '@logistics-frontend/blocks'
import React from 'react'
import {useController, useFormContext} from 'react-hook-form'

type InputControlledType = Omit<InputProps, 'name' | 'value'> & {name: string}

export const InputControlled = ({name, ...props}: InputControlledType): React.ReactElement => {
  const {control} = useFormContext()
  const {field} = useController({control, defaultValue: '', name})

  return <Input {...props} {...field} value={field.value} />
}
